<template>
  <v-card>
    <v-card-title class="headline primary white--text justify-center">
      Sugestão para assinatura
    </v-card-title>
    <v-card-text>
      <div class="text-xs-center primary--text font-weight-medium display-1 mb-3">
        Insira o CPF do Usuário
      </div>
      <v-text-field
        v-model.lazy="cpf"
        :loading="loading"
        box
        hide-details
        single-line
        color="primary"
        clearable
        class="centered-input display-1 font-weight-black"
        mask="###.###.###-##"
        style="width: 100%;"
      />
      <v-btn
        color="primary"
        block
        class="mt-3"
        @click="historicoCompras"
        :loading="loading"
        :disabled="loading"
      >
        Buscar
      </v-btn>
      <v-sheet
        v-if="MostrarSugestao && mensagemSugestao"
        class="pa-2 mt-3 rounded"
        color="blue lighten-5"
      >
        <div class="d-flex align-start">
          <v-icon small class="mr-2 primary--text">mdi-robot-outline</v-icon>
          <div class="flex-grow-1 sug-ia-content">
            <div class="d-flex align-center">
              <div class="title font-weight-bold primary--text mb-2">
                Aqui vai uma sugestão...
              </div>
            </div>
            <div class="body-2 primary--text ia-msg">
              {{ mensagemSugestao }}
            </div>
          </div>
          <v-btn icon x-small class="ml-2" @click="MostrarSugestao = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    cpf: '',
    MostrarSugestao: true,
    mensagemSugestao: ''
  }),
  computed: {
    empresa () {
      return this.$store.getters.empresa
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    historicoCompras () {
      const cpf = String(this.cpf || '').replace(/\D/g, '')
      if (cpf.length !== 11) return

      const empresa = ((this.empresa && this.empresa.cnpj) ? String(this.empresa.cnpj) : '').replace(/\D/g, '')

      const params = { cpf }
      if (empresa) params.empresa = empresa

      const payload = {
        aps: 1,
        method: 'POST',
        params,
        body: {}
      }
      return this.$store.dispatch('historicoCompras', payload)
        .then(json => {
          if (json) this.sugestaoFidelize(json)
        })
        .catch(() => {})
    },
    sugestaoFidelize (historico) {
      this.$store.dispatch('sugestaoFidelize', { historico })
        .then((json) => {
          if (json && json.sugestao) {
            this.mensagemSugestao = json.sugestao
            this.MostrarSugestao = true
          }
        })
    }
  }
}
</script>

<style scoped>
    .ia-msg {
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
    }
    .sug-ia-content {
        min-width: 0;
    }
</style>
